import {
	headerDrawerContainerSX,
	headerMenuPanelSX,
} from '@/components/content/Header/styles/headerMenuPanel';
import {
	Box,
	ClickAwayListener,
	Drawer,
	Fade,
	Popover,
	Stack,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { FC, useEffect } from 'react';

type Props = {
	id?: string;
	isOpen: boolean;
	handleClose: () => void;
	children: JSX.Element;
	anchorEl: HTMLDivElement | null;
};

export const HeaderMenuPanel: FC<Props> = ({
	id = 'storeSelectorPanel',
	isOpen,
	handleClose,
	anchorEl,
	children,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
	useEffect(() => {
		handleClose();
	}, [isMobile]);

	const content = <Stack direction="column">{children}</Stack>;

	return (
		<>
			{isMobile ? (
				<Fade in={isOpen} timeout={500}>
					<Box>
						<Drawer
							open={isOpen}
							onClose={handleClose}
							sx={headerDrawerContainerSX}
							anchor="bottom"
							elevation={4}
							variant="temporary"
							PaperProps={{
								id,
							}}
						>
							<ClickAwayListener onClickAway={handleClose}>{content}</ClickAwayListener>
						</Drawer>
					</Box>
				</Fade>
			) : (
				<Popover
					sx={headerMenuPanelSX}
					open={isOpen}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					slotProps={{ paper: { id } }}
					TransitionComponent={Fade}
					transitionDuration={500}
				>
					{content}
				</Popover>
			)}
		</>
	);
};
